import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'bootstrap-imageupload';

class ResponsivePageLayoutA extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const rightStyle = this.props.rightStyle || {}
        const leftStyle = this.props.leftStyle || {}
        return (
            <div className="responsive-layout">
                <div className={`body-content ocol-5A responsive-layout-left ${this.props.leftClass || ""}`} style={{ float:"left", position:"fixed", ...leftStyle }}>
                    {this.props.left()}
                </div>

                {
                    !this.props.noDivider && <div className="vl"></div>
                }

                <div className={`container body-content ocol-7A responsive-layout-right ${this.props.rightClass || ""}`} style={{ float:"right", ...rightStyle }}>
                    {this.props.right()}
                </div>

                <div className="order-bottom-bar">
                    {this.props.bottom()}
                </div>
            </div>
        );
    }
}

ResponsivePageLayoutA.propTypes = {
    left: PropTypes.func,
    right: PropTypes.func,
    bottom: PropTypes.func
}
ResponsivePageLayoutA.defaultProps = {
    left: null,
    right: null,
    bottom: null,
}

export default ResponsivePageLayoutA;